import { useState, useEffect } from "react";

export default function TypewriterText({ text = "", speed = 100, loop = false, className = "" }) {
  const [displayedText, setDisplayedText] = useState("");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (index < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + text.charAt(index));
        setIndex((prev) => prev + 1);
      }, speed);
      return () => clearTimeout(timeout);
    } else if (loop) {
      // restart after a short delay
      const resetTimeout = setTimeout(() => {
        setDisplayedText("");
        setIndex(0);
      }, 1500);
      return () => clearTimeout(resetTimeout);
    }
  }, [index, text, speed, loop]);

  const classNames = `typewriter-text ${className}`;

  return (
    <span className={classNames}>
      {displayedText}
      <span className="cursor font-thin">|</span>
    </span>
  );
}
